import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import {
  SHOW_SIGN_IN_POPUP_MODAL,
  HIDE_GLOBAL_LOADER_POPUP_MODAL
} from "@constants/actionTypes";
import { SHOW_REFER_POPUP_MODAL } from "@constants/refer";
import { defaultAction } from "@actions/defaultAction";
import classNames from "classnames";
import loadable from "@loadable/component";
const CardCashSpinner = loadable(() =>
  import(
    /* webpackChunkName: "CardCashSpinner" */ "../../../components/CardCashSpinner"
  )
);

const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 109;
  background-color: rgba(31, 32, 33, 0.9);

  @media (max-height: 575px) {
    position: absolute;
    margin-top: 109px;
    height: 100%;
  }
`;

const LoaderContainer = styled.div`
  position: relative;
  transform: translate(0%, 50%);
`;

const LoaderPopup = ({
  showGlobalLoaderPopup,
  hidePopUpModal,
  globalPopupInitiator,
  customerGetStatus,
  showSignInPopup,
  openReferModal
}) => {
  useEffect(() => {
    const referArray = ["homeRefer", "footerRefer"];
    if (referArray.includes(globalPopupInitiator)) {
      if (customerGetStatus === "failed") {
        closeModal();
        showSignInPopup(globalPopupInitiator);
      }
      if (customerGetStatus === "success") {
        closeModal();
        openReferModal();
      }
    }
  }, [customerGetStatus]);

  useEffect(() => {
    if (showGlobalLoaderPopup) {
      document.body.style.overflow = "hidden";
    }
    return () => (document.body.style.overflow = "initial");
  }, [showGlobalLoaderPopup]);

  const closeModal = () => {
    hidePopUpModal();
  };

  return (
    <PopUpContainer className={classNames("animated", "fast", "fadeInUp")}>
      <LoaderContainer>
        <CardCashSpinner />
      </LoaderContainer>
    </PopUpContainer>
  );
};

export default connect(
  state => ({
    showGlobalLoaderPopup: state.userActions.showGlobalLoaderPopup,
    globalPopupInitiator: state.userActions.globalPopupInitiator,
    customerGetStatus: state.customerInfo.customerGetStatus
  }),
  dispatch => ({
    hidePopUpModal: () =>
      dispatch(defaultAction(HIDE_GLOBAL_LOADER_POPUP_MODAL)),
    showSignInPopup: initiator =>
      dispatch(defaultAction(SHOW_SIGN_IN_POPUP_MODAL, initiator)),
    openReferModal: () => dispatch(defaultAction(SHOW_REFER_POPUP_MODAL, true))
  })
)(LoaderPopup);
